export { default } from './DotDot';

import './DotDot.scss';
